import ApiHandler from '../ApiHandler';

class ProspectorProApiHander extends ApiHandler {
  addTokenToData(data) {
    return Object.assign(
      {},
      data || {},
      { token: process.env.VUE_APP_PP_API_TOKEN },
    );
  }

  addTokenAsQueryString(url) {
    return `${url}?token=${process.env.VUE_APP_PP_API_TOKEN}`;
  }

  get(url, data, identifier, fullResponse) {
    return super.get(url, this.addTokenToData(data), identifier, fullResponse);
  }

  post(url, data, identifier, fullResponse) {
    return super.post(
      this.addTokenAsQueryString(super.addIdentifierToUrl(url, identifier)),
      data,
      '',
      fullResponse,
    );
  }

  postRaw(url, data, identifier, fullResponse) {
    return super.postRaw(
      this.addTokenAsQueryString(super.addIdentifierToUrl(url, identifier)),
      data,
      '',
      fullResponse,
    );
  }

  put(url, data, identifier, fullResponse) {
    return super.put(
      this.addTokenAsQueryString(super.addIdentifierToUrl(url, identifier)),
      data,
      '',
      fullResponse,
    );
  }

  putRaw(url, data, identifier, fullResponse) {
    return super.putRaw(
      this.addTokenAsQueryString(super.addIdentifierToUrl(url, identifier)),
      data,
      '',
      fullResponse,
    );
  }
}

const prospectorProApiHander = new ProspectorProApiHander();
export default prospectorProApiHander;
